/*
 * "You've selected Small. There are other sizes." -- shown before a one-option
 * product goes into the cart from a card.
 *
 * The card resolves a variant and shows its price and photograph, but nothing
 * on the card says that the price belongs to one size out of three. On a
 * product photographed as a set -- three vases on a shelf -- that reads as
 * buying all three. This names what is about to be added and offers the way
 * out, before the cart, not after.
 *
 * Everything shown comes from attributes already on the component. No product
 * page is fetched, so the step costs a repaint rather than half a megabyte.
 */
(function () {
  'use strict';

  if (window.__variantConfirmLoaded) return;
  window.__variantConfirmLoaded = true;

  var open = null;

  function close() {
    if (!open) return;
    var el = open;
    open = null;
    el.removeAttribute('open');
    if (el.parentNode) el.parentNode.removeChild(el);
  }

  function build(component, button) {
    var option = component.dataset.variantOption || 'Option';
    var selected = component.dataset.variantSelected || '';
    var others = component.dataset.variantOthers || '';
    var url = component.dataset.productUrl || '';
    var title = component.dataset.productTitle || '';

    var dialog = document.createElement('dialog');
    dialog.className = 'variant-confirm';

    var others_line = others
      ? '<p class="variant-confirm__others">Also available in <strong>' + others + '</strong></p>'
      : '';

    dialog.innerHTML =
      '<div class="variant-confirm__inner">' +
      '<p class="variant-confirm__eyebrow">' + title + '</p>' +
      '<p class="variant-confirm__lead">You’ve selected <strong>' + option + ': ' + selected + '</strong></p>' +
      others_line +
      '<div class="variant-confirm__actions">' +
      '<button type="button" class="variant-confirm__add" data-confirm>Add to cart</button>' +
      (url ? '<a class="variant-confirm__link" href="' + url + '">View product details</a>' : '') +
      '</div>' +
      '<button type="button" class="variant-confirm__close" aria-label="Close" data-close>&times;</button>' +
      '</div>';

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
      if (e.target.closest('[data-close]')) close();
      if (e.target.closest('[data-confirm]')) {
        close();
        // The real add. Both flags come off first: `puppet` so the fly-to-cart
        // plays for this one, `variantConfirmed` so the delegated handler below
        // lets it through. Cleared again straight after, because a second add
        // from the same card should ask again.
        delete button.dataset.puppet;
        component.dataset.variantConfirmed = 'true';
        button.click();
        delete component.dataset.variantConfirmed;
      }
    });

    dialog.addEventListener('close', close);
    return dialog;
  }

  /* Suppress the animation on the click that only opens the confirmation.
   *
   * The fly-to-cart is fired by Horizon's own click handler, bound through its
   * `on:click` framework and delegated from the document -- registered before
   * this file, so it runs first and stopPropagation() below cannot reach it.
   * Without this the image flew to the cart when the dialog opened and again
   * when it was confirmed, announcing an add that had not happened yet.
   *
   * `data-puppet` is Horizon's own opt-out, checked in product-form.js before
   * it animates. Set on pointerdown so it is in place before any click handler
   * runs, whatever order the listeners were registered in. */
  document.addEventListener(
    'pointerdown',
    function (e) {
      var button = e.target.closest('.quick-add__button--add');
      if (!button) return;

      var component = button.closest('quick-add-component');
      if (!component || !component.dataset.variantSelected) return;
      if (component.dataset.variantConfirmed === 'true') return;

      button.dataset.puppet = 'true';
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest('.quick-add__button--add');
      if (!button) return;

      var component = button.closest('quick-add-component');
      if (!component) return;
      if (!component.dataset.variantSelected) return;
      if (component.dataset.variantConfirmed === 'true') return;

      // Before the form hears about it. Capture phase, because the submit is
      // bound on the form itself and would otherwise already be running.
      e.preventDefault();
      e.stopPropagation();

      close();
      var dialog = build(component, button);
      document.body.appendChild(dialog);
      open = dialog;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    },
    true
  );
})();
